import Page, { getProps } from '@/modules/public-service/ppid/request-information'

export const getServerSideProps = getProps

export default Page
